export const parseDigits = (value: string = ''): string => {
  const digits = value.replace(/\D/g, '');
  if (digits.length > 10 && digits.startsWith('1')) {
    return digits.slice(1, 11);
  }
  return digits.slice(0, 10);
};

export const formatVisiblePhoneNumber = (value = '') => {
  if (!value) return '';

  const digits = parseDigits(value);

  if (!digits) return '';

  const part1 = digits.slice(0, 3);
  const part2 = digits.slice(3, 6);
  const part3 = digits.slice(6, 10);

  if (digits.length < 4) return `(${part1}`;
  if (digits.length < 7) return `(${part1}) ${part2}`;
  return `(${part1}) ${part2}-${part3}`;
};



// WEBPACK FOOTER //
// ./src/utils/mask/phone.js